import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import VueRouter from 'vue-router'
import UserValidation from './components/UserValidation.vue'

Vue.use(VueRouter)
Vue.config.productionTip = false;

const router = new VueRouter({
    mode: 'history',
    /*
    We just add one route
     */
    routes: [
        { path: '/assets' },
        {
            path: '*',
            component: UserValidation,
            props: (route) => ({
                to: route.query.to,
                stage: route.query.stage,
                bg: route.query.bg
            })
        }
    ]
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
